import { render, staticRenderFns } from "./InboxMsgIcon.vue?vue&type=template&id=ad8ccf3e&"
import script from "./InboxMsgIcon.vue?vue&type=script&lang=js&"
export * from "./InboxMsgIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports